import { Box, Card, CardContent, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from "@mui/material";

const ValueCell = ({ row }) => {
  const valueContent = (
    <Typography
      component={row.tooltipText ? "span" : "div"}
      sx={{
        fontWeight: row.label === "Total Revenue" ? "600" : "500",
        fontSize: row.label === "Total Revenue" ? "1.125rem" : "1rem",
        color:
          row.highlighted || row.label === "Total Revenue"
            ? "var(--mui-palette-text-primary)"
            : "var(--mui-palette-text-secondary)",
        ...(row.tooltipText
          ? {
              borderBottom: "1px dotted currentColor",
              cursor: "help",
            }
          : {}),
        "@media print": {
          fontSize: "0.875rem",
          margin: 0,
          padding: 0,
          color: "black",
        },
      }}
    >
      {row.value}
    </Typography>
  );

  if (!row.tooltipText) {
    return valueContent;
  }

  return (
    <Tooltip title={row.tooltipText} arrow placement="top">
      {valueContent}
    </Tooltip>
  );
};

export const DashBoardTableCard = ({ data }) => {
  return (
    <Card
      sx={{
        boxShadow: "none",
        borderRadius: "14px",
        "@media print": {
          boxShadow: "none",
          borderRadius: "8px",
          margin: 0,
          padding: "0px",
        },
      }}
    >
      <CardContent
        sx={{
          padding: "0px",
          paddingBottom: "4px !important",
          "@media print": {
            padding: "0px",
            margin: 0,
          },
        }}
      >
        <Table
          sx={{
            "@media print": {
              "& .MuiTableCell-root:not(:last-child)": {
                padding: "6px 8px",
                borderBottom: "1px solid",
                borderColor: "colors.borderVeryLight",
              },
              "& .MuiTableCell-root:last-child": {
                padding: "6px 8px",
              },
            },
          }}
        >
          <TableBody>
            {data.map((row, index, arr) => (
              <TableRow key={index}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    borderBottom: index === arr.length - 1 ? "none" : "1px solid var(--mui-palette-grey-200)",
                    "@media print": {
                      borderBottom: index === arr.length - 1 ? "none" : "1px solid",
                      borderColor: "colors.borderVeryLight",
                    },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: row.highlighted ? "var(--background-section)" : "transparent",
                      borderRadius: "20px",
                      padding: row.highlighted ? "10px 12px" : "0px",
                      pl: row.indented ? 3 : undefined,
                      pr: row.indented ? 1 : undefined,
                      display: "flex",
                      justifyContent: "space-between",
                      "@media print": {
                        padding: "0px",
                        borderRadius: "8px",
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: row.label === "Total Revenue" ? "600" : "500",
                        fontSize: row.label === "Total Revenue" ? "1.125rem" : "1rem",
                        "@media print": {
                          fontSize: "0.875rem",
                          margin: 0,
                          padding: 0,
                        },
                      }}
                    >
                      {row.label}
                    </Typography>
                    <ValueCell row={row} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
